import React from "react";

const SyllabusDetailCardProduct2 = ({
  primaryColor,
  secondaryColor,
  badge,
  optionalBadge,
  title,
  items,
}) => {
  return (
    <div
      className="st-syllabus-detail-card relative rounded-3xl bg-white p-6 sm:p-8 md:p-10"
      style={{
        borderTop: `8px solid ${primaryColor}`,
        backgroundColor: "var(--st-color-syllabus-card-bg)",
      }}
    >
      {optionalBadge && (
        <div className="absolute right-[26px] top-[-6px] sm:right-[36px] sm:top-[-6px]">
          <span
            className="inline-block rounded-b-2xl rounded-t-none px-4 py-1 text-xs font-semibold uppercase tracking-wider shadow-md sm:px-5 sm:py-2 sm:text-xl"
            style={{
              backgroundColor: primaryColor,
              color: secondaryColor,
            }}
          >
            {optionalBadge}
          </span>
        </div>
      )}
      <div className="mb-6 flex items-center gap-4 md:mb-8">
        <span
          className="st-syllabus-detail-badge inline-block rounded-full px-4 py-1 text-xs font-bold uppercase tracking-wider sm:px-5 sm:py-2 sm:text-xl"
          style={{
            backgroundColor: secondaryColor,
            color: primaryColor,
          }}
        >
          {badge}
        </span>
      </div>
      <h4 className="st-font-body text-xl font-normal leading-tight text-black sm:text-3xl md:text-4xl">
        {title}
      </h4>
      <ul className="mt-6 space-y-3 md:mt-8 md:space-y-4">
        {items.map((item, index) => (
          <li
            key={index}
            className="st-font-body flex gap-3 text-sm leading-relaxed text-gray-700 sm:text-base md:text-2xl"
          >
            <span
              className="mt-2 inline-block h-2 w-2 flex-shrink-0 rounded-full sm:mt-3"
              style={{ backgroundColor: primaryColor }}
              aria-hidden="true"
            />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SyllabusDetailCardProduct2;
